<template>

  <div id="index">
     <div v-if="idloading">
      <div class="spinner-box">
       <img src="@/assets/img/loadding_pc.gif" alt="">
        <div>努力加载中...</div>
      </div>
    </div>
    <div v-else class="visible-xs min_index">
      <!-- 头部 -->

      <MinHeader></MinHeader>
      <!-- 留白挤位置 -->
      <div style="width: 100%; height: 50px"></div>
      <!-- ------------------------轮播--------------------------------------------- -->
      <section class="lunbo">
        <!-- Swiper -->
        <div
          class="swiper mySwiper"
          style="position: relative"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper_item swiper-slide"
              data-swiper-autoplay="2000"
              v-for="(liem, index) in banner"
              :key="index"
              @click="bannerFun(liem)"
              :style="{ backgroundImage: 'url(' + $IMG_URL + liem.url + ')' }"
            >
            <div class="zhezao12"  @click="bannerFun(liem)">
            </div>
              <div
                class="zhezao"
                v-if="liem.type == 2"
              >
                <div class="zzzs" v-if="liem.type == 2">
                  <h3>
                    <span v-if="liem.type == 2">【文章】</span>
                    <span> {{ liem.detail.title }}</span>
                  </h3>
                  <!-- <div class="bannew_text">{{ liem.detail.summary }}</div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination1 panaclass"></div>
        </div>
      </section>
      <div class="jiange">
        <div></div>
      </div>
      <!-- ------------------------直播回看--------------------------------------------- -->
      <section class="zb_head">
        <!-- 标题 -->
        <div class="zb_title" style="padding-bottom:1vw">
          <img
            src="@/assets/img/zbhk.png"
            alt=""
          />
          <span>直播回看</span>
        </div>
        <!-- 内容 -->
        <div class="zb_content clearfix">
          <!-- item -->
          <div
            @click="details(item)"
            class="zb_con_item"
            v-for="item in live_arr"
            :key="item.id"
          >
            <img
              :src="isshowimg(item.cover)"
              alt=""
            />
            <div>
              <div class="zb_con_title">
                <span>{{ item.name }}</span>
              </div>
              <div class="zb_con_cons">
                <span>{{ item.doctor }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部 -->
        <div class="zb_more">
          <span @click="gozhibo"><img
              src="@/assets/img/more1.png"
              alt=""
            />更多</span>
          <span @click="huanplayback"><img
              src="@/assets/img/shua1.png"
              alt=""
            />换一换</span>
        </div>
      </section>
      <!-- ------------------------精彩文章--------------------------------------------- -->
      <section class="wz_head">
        <!-- 标题 -->
        <div
          class="zb_title"
          style="margin-left: 3vw;position:relative;margin-right: 3vw;"
        >
          <img
            src="@/assets/img/jcwz.png"
            alt=""
          />
          <span>精彩文章</span>
          <span
            class="wz_more"
            @click="gowzmore"
          >更多></span>
        </div>
        <!-- 内容 -->
        <div
        v-if="article_list[0]"
          class="wz_item1"
          @click="new_details(article_list[0].news_id)"
        >
          <div v-if="article_list[0]" style="padding-left: 1vw;font-size: 3.89vw;"> {{article_list[0].title}}</div>
          <div
            class="lm_con_bot"
            style="width:auto;margin:3vw 0px;padding-right:0vw"
          >
            <span ><i class="el-icon-user-solid"></i>{{ article_list[0].user }}</span>
            <span
              style=""
              class="bot_span"
            >{{ article_list[0].create_time.split(" ")[0] }}</span>
          </div>
          <img
            :src="isshowimg(article_list[0].video_image)"
            style="border-radius: 2vw;overflow: hidden;"
            alt=""
          >
        </div>
        <!-- item  -->
        <div
          class="lm_con_item"
          v-for="item in article_list.slice(1, 4)"
          :key="item.news_id"
          @click="new_details(item.news_id)"
        >
          <img
            :src="isshowimg(item.video_image)"
            alt=""
            style="display: inline-block"
          />
          <div
            class="lm_con_right"
            style="display: inline-block"
          >
            <div class="lm_con_top">
              {{ item.title }}
            </div>
            <div class="lm_con_bot">
              <span><i class="el-icon-user-solid"></i>{{ item.user }}</span>
              <span class="bot_span">{{ item.create_time.split(" ")[0] }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="wz_content clearfix">
          <div
            class="wz_con_item"
            v-for="item in article_list"
            :key="item.news_id"
            @click="new_details(item.news_id)"
          >
            <img :src="item.video_image" alt="" />
            <div>
              <div class="wz_con_title">
                <span>{{ item.title }}</span>
              </div>
              <div class="wz_con_cons">
                <span><i class="el-icon-user-solid"></i>{{ item.user }}</span>
                <span>{{ item.create_time.split(" ")[0] }}</span>
              </div>
            </div>
          </div>
        </div> -->
      </section>
      <!-- ------------------------栏目--------------------------------------------- -->
      <section class="lm_head">
        <div
          class="lm_title"
          style="position: relative"
        >
          <div class="lm_tit_top">
            <span>栏目</span>
            <span @click="molanmu">更多> </span>
          </div>
          <!-- tab栏 -->
          <div class="lm_tabs">
            <div class="tabs_contnet" v-if="newConf_list[0]">
              <span
                v-for="(item, index) in newConf_list"
                :key="item.id"
                @click="demoClick(index)"
                :class="{ tabacrive: index == tabNum }"
              >
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
        <div class="lm_content clearfix" v-if="newConf_list[tabNum]">
          <!-- item  -->
          <div
            class="lm_con_item"
            v-for="item in newConf_list[tabNum].news.slice(0, 3)"
            :key="item.news_id"
            @click="new_details(item.news_id)"
          >
           
            <img
              :src="isshowimg(item.video_image)"
              alt=""
              style="display: inline-block"
            />
            <div
              class="lm_con_right"
              style="display: inline-block"
            >
              <div class="lm_con_top">
                {{ item.title }}
              </div>
              <div class="lm_con_bot">
                <span><i class="el-icon-user-solid"></i>{{ item.user }}</span>
                <span class="bot_span">{{
                  item.create_time.split(" ")[0]
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- ------------------------视频--------------------------------------------- -->
      <section class="sp_head">
        <div class="sp_title" style="padding-top: 10px">
          <div class="sp_tit_top">
            <div>
              <img
                src="@/assets/img/ship34.png"
                alt=""
              />
              <span>精彩视频</span>
            </div>
            <span @click="$router.push({name:'mvedioIndex'})">更多> </span>
          </div>
        </div>
        <!-- 内容 -->
        <div class="sp_top">
          <div
            class="sp_top_lf"
            style="margin-right: 2.43vw"
          >
            <div
              @click="openvedi(video[0])"
              class="borderra"
              style="margin-bottom: 2.2vw"
            >
              <img
                :src="video[0].cover"
                alt=""
              />
              <div class="top_left_over"></div>
              <img
                src="@/assets/img/home/icon_bf.png"
                alt=""
                class="play_icon"
              />
              <p class="video_title">{{ video[0].title }}</p>
            </div>
            <div
              @click="openvedi(video[1])"
              class="borderra"
            >
              <img
                :src="video[1].cover"
                alt=""
              />
              <div class="top_left_over"></div>
              <img
                src="@/assets/img/home/icon_bf.png"
                alt=""
                class="play_icon"
              />
              <p class="video_title">{{ video[1].title }}</p>
            </div>
          </div>
          <div
            @click="openvedi(video[2])"
            class="sp_top_rg borderra"
          >
            <img
              :src="video[2].cover"
              alt=""
            />
            <div class="top_right_over"></div>
            <img
              src="@/assets/img/home/icon_bf.png"
              alt=""
              class="play_icon"
            />
            <p
              class="video_title"
              style="bottom: 4.6vw"
            >
              {{ video[2].title }}
            </p>
          </div>
        </div>
        <div class="sp_top borderra">
          <div
            class="sp_top_rg"
            @click="openvedi(video[3])"
            style="margin-right: 4.43vw;width:43.07vw"
          >
            <img
              :src="video[3].cover"
              alt=""
            />
            <div class="top_right_over"></div>
            <img
              src="@/assets/img/home/icon_bf.png"
              alt=""
              class="play_icon"
            />
            <p
              class="video_title"
              style="bottom: 4.6vw"
            >
              {{ video[3].title }}
            </p>
          </div>
          <div class="daka">
            <div
              class="borderra"
              @click="opencate(videoConf[0])"
              style="margin-bottom: 1.6vw"
            >
              <img
                :src="videoConf[0].image"
                alt=""
              />
              <div class="bot_mini_over"></div>
              <p class="center">{{ videoConf[0].title }}</p>
            </div>
            <div
              class="borderra"
              @click="opencate(videoConf[1])"
              style="margin-bottom: 1.6vw"
            >
              <img
                :src="videoConf[1].image"
                alt=""
              />
              <div class="bot_mini_over"></div>
              <p class="center">{{ videoConf[1].title }}</p>
            </div>
            <div
              class="borderra"
              @click="opencate(videoConf[2])"
            >
              <img
                :src="videoConf[2].image"
                alt=""
              />
              <div class="bot_mini_over"></div>
              <p class="center">{{ videoConf[2].title }}</p>
            </div>
          </div>
        </div>
      </section>
      <!-- ------------------------条漫--------------------------------------------- -->
      <section class="tm_head">
        <!-- 标题 -->
        <div class="zb_title" style="padding-bottom:1vw">
          <img
            src="@/assets/img/tiaoman.png"
            alt=""
          />
          <span>条漫</span>
        </div>
        <!-- 内容 -->
        <div style="display: flex">
          <div class="tm_left">
            <div
              class="tm_left_item"
              v-for="item in picture"
              :key="item.id"
              @click="picturego(item.id)"
            >
              <img
                :src="item.image"
                alt=""
              />
              <div class="tm_item_title">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
          <div class="tm_right">
            <div class="tm_top">
              <p style="margin-top: 2vw">扫码获取</p>
              <p>知麻胡系列</p>
              <p>表情包</p>
              <div class="tm_icon"></div>
            </div>
            <div style="margin-top: 5.8vw">
              <img
                src="@/assets/img/bot_tm.png"
                alt=""
              />
            </div>
            <div style="margin-top: 5.8vw">
              <img
                src="@/assets/img/midlo_tm.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <!-- 提示注册弹窗 -->
      <LoginPrompt
        @promptFun="promptFun"
        ref="prompt"
      ></LoginPrompt>
        <LoginPrompt1 @promptFun1="promptFun1" ref="prompt1"></LoginPrompt1>

    </div>
      <!-- 尾部 -->
      <MinFooter headIndex="1"></MinFooter>
  </div>
</template>

<script>
import MinHeader from "@/components/m_assembly/MinHeader.vue"; //头部模块
import MinFooter from "@/components/m_assembly/MinFooter.vue"; //尾部模块
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
import LoginPrompt1 from "@/components/assembly/LoginPrompt1.vue"; //注册弹窗模块
import MListLi from "@/components/assembly/m_listLi.vue"; //列表数据模块
import Hezuo from '@/components/tool/m_hezuo.vue'

import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";

export default {
  name: "index",
  data () {
    return {
      head_index: 1, //2推荐 3关注 4热门
      is_pc: true, //是否是pc端打开
      user: {}, //用户信息
      page: 1,
      list_arr: [],
      is_request: false,

      live: [], //直播列表
      //   懒加载
      loadingimg: "@/assets/img/loadding.gif",
      isloading: false,
      activeName: "1", //tab栏
      live_arr: [], //直播数组
      article_list: [], //文章
      newConf_list: [], //栏目
      video: [], //视频
      videoConf: [], //小视频
      picture: [], //条漫
      tabNum: 0, //当前tab
      banner: [], //轮播
      data_arr: [], //文章 栏目 视频 条漫
      activity: false, //活动
      idloading:true
    };
  },
  computed: {
    MembershipType: function () {
      return this.MembershipGrade(this.user.plus);
    },
  },
  components: {
    MinHeader,
    MinFooter,
    LoginPrompt,
        LoginPrompt1,
    MListLi,
    Hezuo
  },
  watch: {
    head_index: function (eve) {
      this.page = 1;
      //   this.getList();
    },
  },
  created () {
    this.idloading=true
    this.playback();
    this.getArt();
  },
  methods: {
     promptFun1(){
      this.registered(1);
    },
    prompt1Show() {
      //打开提示弹窗回调
      this.$refs.prompt1.popupFun1();
    },
    prompt2Show() {
      //打开审核状态提示语弹窗回调
      this.$refs.prompt1.popupFun2();
    },
    swiperFun () {
      //实例swiper
      new Swiper(".mySwiper", {
        pagination: ".swiper-pagination1",
        loop: true,
        // autoplay: {
        //   delay: 2000, //1秒切换一次
        // },
      });
    },
    request () {
      //获取banner
      let that = this;
      this.$get("banner_lists", { name: 2 }).then((res) => {
         
        that.banner = res.data;
        that.$nextTick(function () {
          setTimeout(() => {
            that.swiperFun();
          }, 200);
        });
      });
    },
    //   tab切换
    demoClick (index) {
      
      this.isloading = true;
      
      this.tabNum = index;
      setTimeout(() => {
        this.isloading = false;
      }, 200);
    },
    playback () {
      //获取录播列表
      let that = this;
      this.$get("record_lists", { limit: 10, is_index: 1 }).then((res) => {
        if (res.data.length > 4) {
          that.live_arr = res.data.slice(0, 4);
        } else {
          that.live_arr = res.data;
        }
         
      });
    },
    // 换一换
    huanplayback () {
      let that = this;
      this.$get("record_lists", { limit: 10, is_index: 2 }).then((res) => {
        if (res.data.length > 4) {
          that.live_arr = res.data.slice(0, 4);
        } else {
          that.live_arr = res.data;
        }
         
      });
    },
    // 文章更多跳转
    gowzmore () {
     if (this.USER().id == undefined) {
          this.prompt1Show();
          return false;
      }else{
        console.log(this.USER(),'cjheck')
        if(this.USER().check_status != 1){
          this.prompt2Show();
          return false;
        }
      }
      this.$router.push({
        path: "/m_column",
      });
    },

    openvedi (item) {
      this.$router.push({
        path: "/m_vedio_dteil",
        query: { id: item.id, configid: item.video_conf_id },
      });
    },

    opencate (item) {
      this.$router.push({
        path: "/m_vedio_index",
        query: { id: item.id, catetext: item.title },
      });
    },
    //获取文章和栏目
    getArt () {
      let that = this;
      this.$get("index-data", {}).then((res) => {
        if (res.code == 200) {
          this.data_arr = res.data;
          this.article_list = res.data.article.slice(0, 6);
          this.newConf_list = res.data.newConf.slice(0, 3);
          this.video = res.data.video.slice(0, 4);
          this.videoConf = res.data.videoConf.slice(0, 3);
          this.picture = res.data.picture.slice(0, 3);
           
        }
        //  
      });
    },
    // 直播回看更多跳转
    gozhibo () {
      this.$router.push({
        path: "/m_index",
        query: { id: 2 },
      });
    },
    details (liem) {
      //直播跳转页面
      if (!this.is_judge(liem)) {
        return false;
      }
      let id = liem.id;
      let record_url = liem.record_url;
      let power = liem.power;
      if (this._isMobile()) {
        // alert("手机端");
        if (this.selectBox_index == 1) {
          //直播
          this.$router.push({
            path: "min_move",
            query: { id: id, url: record_url, power: power },
          });
        } else {
          this.$router.push({
            path: "min_record",
            query: { id: id, url: record_url, power: power },
          });
        }
      } else {
        // alert("pc端");
        if (this.selectBox_index == 1) {
          //直播
          this.$router.push({
            path: "pc_move",
            query: { id: id, url: record_url, power: power },
          });
        } else {
          this.$router.push({
            path: "pc_record",
            query: { id: id, url: record_url, power: power },
          });
        }
      }
    },
    is_judge (liem) {
      //判断登录
      //  
      if (!liem.detail || !liem.detail.power) {
        return true;
      }
      if (liem.detail.power == 0) {
        return true;
      }
      if (!this.USER()) {
        this.$refs.header.promptShow();
        layer.open({
          content: "请先登录账号",
          time: true,
          skin: "msg",
        });
        setTimeout(() => {
          this.$refs.header.registered(1);
        }, 1000);

        return false;
      }
      if (
        (this.USER().plus < 2 && liem.detail.power == 2) ||
        (this.USER().plus == 0 && liem.detail.power == 1)
      ) {
        layer.open({
          content: this.promptPermissions,
          time: true,
          skin: "msg",
        });
        return false;
      }
      return true;
    },
    //文章详情
    new_details (id) {
      if (this.USER().id == undefined) {
          this.prompt1Show();
          return false;
      }else{
        console.log(this.USER(),'cjheck')
        if(this.USER().check_status != 1){
          this.prompt2Show();
          return false;
        }
      }
      this.$router.push({
        path: "/m_column_details",
        query: { id: id, head_index: 2 },
      });
    },
    // 更多栏目
    molanmu () {
    if (this.USER().id == undefined) {
          this.prompt1Show();
          return false;
      }else{
        console.log(this.USER(),'cjheck')
        if(this.USER().check_status != 1){
          this.prompt2Show();
          return false;
        }
      }
      this.$router.push({
        path: "/m_column",
      });
    },
    // 条漫跳转
    picturego (id) {
       
      this.$router.push({
        path: "m_column",
        query: { id: id },
      });
    },
    bannerFun (liem) {
      //轮播跳转
      if (isNaN(liem.live_id)) {
        window.location.href = liem.live_id;
        return false;
      }
      if (!liem.detail && liem.type == 5) {
        // window.location.href = liem.href;
        window.open(liem.href);
        return;
      }
      if (!this.is_judge(liem)) {
        return false;
      }
      
      if (this._isMobile()) {
        // alert("手机端");
        if (liem.type == 1) {
          //直播
          this.$router.push({
            path: "min_move",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        } else if (liem.type == 2) {
           if (this.USER().id == undefined) {
              this.prompt1Show();
              return false;
          }else{
            console.log(this.USER(),'cjheck')
            if(this.USER().check_status != 1){
              this.prompt2Show();
              return false;
            }
          }
          //文章
          this.$router.push({
            path: "/m_column_details",
            query: { id: liem.news_id, head_index: 2 },
          });
        } else if (liem.type == 3) {
           
            this.$router.push({
          path: "/m_vedio_dteil",
          query: { id: liem.video_id, configid: liem.detail.video_conf_id },
        });
          // 3视频
        } else if (liem.type == 4) {
           
          // 4会议
        }
        // else {
        //   this.$router.push({
        //     path: "min_record",
        //     query: {
        //       id: liem.live_id,
        //       url: liem.detail.live_url,
        //       power: liem.detail.power,
        //     },
        //   });
        // }
      } else {
        // alert("pc端");
        if (liem.type == 1) {
           
          //直播
          this.$router.push({
            path: "pc_move",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        } else if (liem.type == 2) {
           
          //文章
          this.$router.replace({
            path: "/column_details",
            query: { id: liem.news_id, head_index: 2 },
          });
        } else if (liem.type == 3) {
           
          // 3视频
        } else if (liem.type == 4) {
           
          // 4会议
        }
        //  else {
        //   this.$router.push({
        //     path: "pc_record",
        //     query: { id: liem.live_id, url: liem.play_url, power: liem.power },
        //   });
        // }
      }
    },
    // 活动跳转
    go_activity (liem) {
      this.$router.push({ path: "m_activity", query: { id: liem.id } });
    },
    go_live (liem) {
      //跳转直播
      this.$router.push({
        path: "./min_move",
        query: { id: liem.id, url: liem.record_url, power: liem.power },
      });
    },
    detailsFun (id) {
      //查看详情

      let arr = $(window).scrollTop() + $(window).height();
      this.$store.commit("pageFun", arr);
      this.$router.push({ path: "/m_column_details", query: { id: id } });
    },
    promptFun () {
      //提示弹窗回调
      this.$router.replace("/m_registered");
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();

      that.user = that.USER();
      // that.getList();
    },
    // getList() {
    //   //获取列表数据
    //   let that = this;
    //   this.is_request = false;
    //   if (this.page == 1) {
    //     this.list_arr = [];
    //   }
    //   this.$post("news_recomm", {
    //     type: this.head_index,
    //     member_id: this.USER().id,
    //     limit: 10,
    //     keyword: this.keyword,
    //     page: this.page,
    //   })
    //     .then((res) => {
    //        
    //       let arr = [];
    //       that.is_request = true;
    //       if (that.head_index == 2) {
    //         let data = res.data.data.data;
    //         let recomm = res.data.recomm.data;
    //         let indexT = 0;
    //         data.forEach((liem, index) => {
    //           if ((indexT / 2) % 1 === 0 && recomm[indexT]) {
    //             arr.push(recomm[indexT]);
    //             indexT++;
    //           }
    //           arr.push(liem);
    //         });
    //       } else {
    //         arr = res.data.data;
    //       }
    //       that.live = res.data.live;
    //       that.activity = res.data.activity ? res.data.activity : false;
    //       that.list_arr = that.list_arr.concat(arr);
    //       that.$nextTick(() => {
    //         that.$refs.listLi.videoFun();
    //       });
    //     })
    //     .catch((res) => {
    //       that.is_request = true;
    //     });
    // },
    test (desc) {
      //判断是否是app打开页面
      this.$store.commit("setApp", true);
    },
  },
   activated () {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    let _this = this
    setTimeout(() => {
      let arr = document.querySelectorAll('[data-swiper-slide-index="0"]')
      arr[1].addEventListener('click', function () {
        _this.bannerFun(_this.banner[0])
        console.log(112121);
      }, false);
    }, 1000);

  },
  mounted () {
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    this.idloading=false

    let that = this;

    if (this.$store.state.pageNum > 0) {
      console.warn(that.$store.state.pageNum);
      setTimeout(() => {
        $("html,body").animate({ scrollTop: that.$store.state.pageNum }, 800);
      }, 800);
    }
    this.head_index = 2;
    this.getShare();
    this.getUser();
    this.request();
    let _this = this
    setTimeout(() => {
      let arr = document.querySelectorAll('[data-swiper-slide-index="0"]')
      arr[1].addEventListener('click', function () {
        _this.bannerFun(_this.banner_arr[0])
        console.log(112121);
      }, false);
    }, 1000);
    window.test = this.test;
    if (this.GetRequest().code) {
      window.location.href = this.$VIEW_URL;
    }
    if (this._isMobile()) {
    } else {
      // alert("pc端");
      this.$router.replace("/");
    }

    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        // that.getList();
      }
    });
  },
};
</script>

<style  scoped>
html,
body {
  max-width: 100vw;
}
.clearfix:after {
  content: "."; /*加一段内容*/
  display: block; /*让生成的元素以块级元素显示，占满剩余空间*/
  height: 0; /*避免生成的内容破坏原有布局高度*/
  clear: both; /*清除浮动*/
  visibility: hidden; /*让生成的内容不可见*/
}
.clearfix {
  zoom: 1; /*为IE6，7的兼容性设置*/
}
#index {
  padding-top: 0;
}

header.header {
  box-shadow: 0 !important;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem !important;
}
.eltabs /deep/ .el-tabs__nav-wrap::after {
  display: none;
}
/* 轮播 */
.lunbo {
  width: 100%;
  height: 50.66vw;
  /* margin-bottom: 3.99vw; */
  /* background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(141, 141, 141, 0.45) 38%,
    #000000 100%
  ); */
}
.jiange {
  width: 100%;
  height: 3.9vw;
  background-color: #000000;
  position: relative;
}
.jiange div {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 4vw;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  overflow: hidden;
  background-color: #fff;
}
/* 直播回看 */
.zhezao {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background: linear-gradient(to top, #000000ba 0%, #ffffff00 57%);
  /* background-image: linear-gradient(to top, #000000ba 0%, #ffffff00 59%) */
}
.zhezao12{
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.zhezao h3 {
  font-weight: bold;
  font-size: 4.2vw;
  letter-spacing: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.zzzs {
  position: absolute;
  bottom: 6vw;
  left: 5vw;
  width: 90%;
  color: #fff;
  text-align: left;
}
.bannew_text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 2.13vw;
  padding-top: 1vw;
  padding-left: 2vw;
}
.zb_head {
  padding: 0px 3.99vw;
}
.zb_content {
}
.zb_title {
  padding-bottom: 4vw;
}
.zb_title > img {
  width: 4.79vw;
  height: 4.79vw;
  vertical-align: sub;
  object-fit: cover;
}
.zb_title > span {
  font-size: 4vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0px;
  color: #333333;
  opacity: 1;
  font-weight: 600;
}
.zb_con_item {
  margin-top: 1.083333rem;
  width: 44.73vw;
  float: left;
}
.zb_con_item:nth-child(even) {
  margin-left: 2.4vw;
}
.zb_con_item img {
  width: 44.73vw;
  height: 25.29vw;
  border: 0px solid #b381fe;
  opacity: 1;
  border-radius: 1vw;
  background-color: aquamarine;
  margin-bottom: 2.13vw;
}
.zb_con_item .zb_con_title,
.zb_con_cons {
  width: 44.2vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.zb_con_title {
  margin-bottom: 1.33vw;
  color: #333333;
  font-size: 3.79vw;
  font-weight: 600;
}
.zb_con_cons {
  font-size: 3.13vw;
  color: #666666;
}
.zb_more {
  width: 91.59vw;
  height: 7.99vw;
  line-height: 7.99vw;
  background: #f5f5f5;
  opacity: 1;
  border-radius: 8vw;
  margin-top: 3.99vw;
}
.zb_more span {
  display: inline-block;
  width: 49%;
  color: #999999;
  text-align: center;
  font-size: 3.3vw;
}
.zb_more img {
  width: 3.2vw;
  height: 2.96vw;
  margin-right: 1vw;
  vertical-align: unset;
}
/* 文章详情 */
.wz_head {
  padding: 0px 1.99vw;
  margin-top: 5.59vw;
  margin-bottom: 10px;
}
.wz_content {
}
.wz_con_item {
  float: left;
  margin-top: 3.5vw;
  width: 29.09vw;
  height: 39vw;
  background: #ffffff;
  box-shadow: 0vw 0vw 1vw rgba(0, 0, 0, 0.16);
  opacity: 1;
  /* margin-bottom: 3.46vw; */
  margin-left: 2.1vw;
}
.wz_con_item img {
  width: 29.02vw;
  height: 22.36vw;
  background: #d42626;
  opacity: 1;
  border-radius: 1vw 1vw 0vw 0vw;
  margin-bottom: 1.8vw;
}
.wz_con_title {
  width: 27.42vw;
  height: 7.8vw;
  font-size: 2.66vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  padding-left: 1.3vw;
  opacity: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.wz_con_cons {
  display: flex;
  justify-content: space-between;
  margin-top: 1.86vw;
  width: 26.42vw;
  font-size: 1.86vw;
  padding-left: 1.3vw;
  padding-right: 1.3vw;
}
.wz_con_cons span:first-child {
  width: 15vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wz_con_cons span:last-child {
  padding-top: 0.5vw;
}
/* 栏目 */
.lm_head {
  margin-top: 7vw;
  padding: 0px 4vw;
  margin-bottom: 10px;
}
.lm_title {
  width: 91.59vw;
  height: 21.03vw;
  background: url("../../assets/img/lanmubac.png") no-repeat;
  background-size: cover;
  border-radius: 2vw;
  overflow: hidden;
}
.lm_tit_top {
  width: 87.59vw;
  height: 4.79vw;
  line-height: 4.79vw;
  display: flex;
  justify-content: space-between;
  margin: 0px auto;
  padding-top: 4.26vw;
}
.lm_tit_top span:first-child {
  height: 4.79vw;
  font-size: 4.79vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
}
.lm_tit_top span:last-child {
  width: 9.8vw;
  height: 3.19vw;
  font-size: 3.19vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 1;
}
.lm_tabs {
  width: 100%;
  height: 8vw;
  position: absolute;
  bottom: 0px;
}
.tabs_contnet {
  width: 88.59vw;
  display: flex;
  justify-content: space-between;
}
.lm_tabs span {
  margin-left: 2vw;
  height: 7vw;
  line-height: 6.19vw;
  font-size: 3.89vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
}
.tabacrive {
  border-bottom: 1vw solid #1f93f7;
}
.lm_con_item {
  width: 91.59vw;
  height: 23.43vw;
  box-shadow: 0vw 1vw 2vw rgba(0, 0, 0, 0.15);
  border-radius: 2vw;
  margin: 0 auto;
  margin-top: 2.93vw;
  overflow: hidden;
}
.wz_item1 {
  width: 91.59vw;
  margin: auto;
  padding: 10px;
  border-radius: 2vw;
  box-sizing: border-box;
  box-shadow: 0vw 1vw 2vw rgb(0 0 0 / 15%);

}
.wz_item1 img {
  width: 91.59vw;
  height: 44.43vw;
  object-fit: cover;
}
.lm_con_item img {
  vertical-align: bottom;
  width: 39.14vw;
  height: 23.43vw;
  background: #12687e;
  border-radius: 1vw 0rem 0rem 1vw;
  object-fit: cover;
}
.lm_con_right {
  width: 40vw;
  height: 23.43vw;
  margin-left: 4.7vw;
}
.lm_con_top {
  width: 43.66vw;
  height: 11vw;
  font-size: 3.89vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
margin-top: 1.73vw;
    margin-bottom: 4vw;
}
.zb_title .wz_more {
  position: absolute;
  right: 0;
  top: 2.1vw;
  font-size: 3.13vw;
  color: #666;
  font-weight: normal;
}

.el-icon-user-solid {
  vertical-align: middle;
}
.bot_span {
  padding-top: 1vw;
}
.borderra {
  border-radius: 3vw;
  overflow: hidden;
}
.lm_con_bot {
  width: 42.66vw;
  /* height: 2.13vw; */
  font-size: 3.13vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  opacity: 1;
  display: flex;
  justify-content: space-between;
}
/* 视频 */
.sp_head {
  width: 93.39vw;
  height: 136.73vw;
  /* background: url("../../assets/img/spcon.png") no-repeat; */
  background-size: cover;
  margin: auto;
  margin-top: 2vw;
}
.sp_tit_top {
  width: 92.59vw;
  height: 5.79vw;
  line-height: 4.79vw;
  display: flex;
  justify-content: space-between;
  margin: 0px auto;
  padding-top: 3vw;
}
.sp_tit_top div span {
  /* height: 4.79vw; */
  font-size: 4vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0px;
  color: #333333;
  opacity: 1;
  font-weight: 600;
}
.sp_tit_top div img {
  width: 4.79vw;
  height: 4.79vw;
  vertical-align: sub;
  object-fit: cover;
}
.sp_tit_top > span {
  width: 10.64vw;
  height: 3.19vw;
  font-size: 3.19vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  opacity: 1;
}
.sp_top {
  width: 92.5vw;
  height: 58.57vw;
  margin: 2.93vw auto;
  display: flex;
}
.sp_top_lf div {
  width: 42.07vw;
  height: 28vw;
  opacity: 1;
  border-radius: 2vw;
  position: relative;
}
.sp_top_lf {
  display: flex;
  flex-direction: column;
}
.sp_top img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sp_top .top_left_over {
  position: absolute;
  bottom: 0px;
  width: 42.07vw;
  height: 24.23vw;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  opacity: 1;
  border-radius: 2vw;
}
.sp_top_rg,
.sp_top_lf {
  width: 45.07vw;
  height: 57.57vw;
  opacity: 1;
  border-radius: 2vw;
  position: relative;
  overflow: hidden;
}
.sp_top .top_right_over {
  position: absolute;
  bottom: 0px;
  width: 45.07vw;
  height: 53.25vw;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  opacity: 1;
  border-radius: 2vw;
}
/* .sp_top_rg::after {
  content: "";
  position: absolute;
  bottom: 0px;
  width: 42.07vw;
  height: 53.25vw;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  opacity: 1;
  border-radius: 1vw;
} */
.daka div {
  width: 45.07vw;
  height: 18.1vw;
  opacity: 1;
  border-radius: 2vw;
  position: relative;
}
.daka .bot_mini_over {
  position: absolute;
  bottom: 0px;
  width: 45.07vw;
  height: 18.1vw;
  background: #000000;
  opacity: 0.3;
}
.sp_top .play_icon {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -40%);
  width: 8vw;
  height: 8vw;
}
.video_title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  position: absolute;
  left: 50%;
  bottom: 2.2vw;
  font-size: 3.89vw;
  width: 35.73vw;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  color: #fff;
}
.center {
  position: absolute;
  text-align: center;
  width: 100%;
  top: 30%;
  left: 50%;
  color: #fff;
  font-size: 5vw;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  font-weight: bold;
}
.tm_head {
  width: 92.39vw;
  margin: 0px 4vw;
  margin-top: 3.19vw;
  margin-bottom: 10vw;
}
.tm_left {
  width: 65.58vw;
  height: 73.63vw;
  background: #ffffff;
  opacity: 1;
  margin-right: 3.2vw;
  margin-top: 0.8vw;
}
.tm_right {
  width: 23.73vw;
  height: 73.63vw;
  background: #ffffff;
  box-shadow: 0vw 1vw 2vw rgba(0, 0, 0, 0.15);
  opacity: 1;
  margin-top: 3.7vw;
}
.tm_left_item {
  width: 65.58wv;
  height: 22.4vw;
  background: #ffffff;
  box-shadow: 0vw 1vw 2vw rgba(0, 0, 0, 0.15);
  opacity: 1;
  margin-top: 3vw;
  border-radius: 1vw;
  overflow: hidden;

  display: flex;
}
.tm_left_item img {
  width: 29.07vw;
  height: 22.4vw;
  background: #ffffff;
  opacity: 1;
  border-radius: 1vw 0rem 0rem 1vw;
  object-fit: cover;
}
.tm_item_title {
  width: 100%;
  text-align: center;
  margin: auto;
  font-size: 3.89vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  opacity: 1;
}
.tm_right img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.tm_right > div {
  width: 19.73vw;
  height: 19.73vw;
  margin: auto;
}
.tm_top {
  display: flex;
  flex-direction: column;
  font-size: 3.13vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  opacity: 1;
  text-align: center;
}
.tm_icon {
  margin: auto;
  width: 2.91vw;
  height: 2.91vw;
  opacity: 0.8;
  background: url(../../assets/img/xiajian.png) no-repeat;
  background-size: cover;
}
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper_item {
  width: 100% !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}

.swiper-pagination1 /deep/ .swiper-pagination-bullet {
  width: 1.5vw;
  height: 1.5vw;
  background: #c5c5c5;
  transition: all 0.5s ease;
  opacity: 1;
  /* margin: 0 0.2vw; */
}

.swiper-pagination1
  /deep/
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 3vw;
  height: 3vw;
  /* border-radius: 6px; */
  background: url(../../assets/img/itemiconpa.png) no-repeat;
  background-size: cover;
  background-position-y: bottom;
}
.panaclass {
  position: absolute;
  z-index: 9;
  bottom: 1vw;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_home.vue